/**
 * Nova MutationObserver on the FIRST span.money.cpc-priceTicker — verbatim
 * from v1 nova_currency.js (research/06 §2, §4; REQ-CUR-3). Preserved bugs:
 * attach THROWS when the span is absent (observe(null) — and
 * `__novaCurrencyObserverAttached` is never set, the assignment comes after
 * observe()), and the case-sensitive `attributeFilter: ['data-origMoney']`
 * NEVER matches (HTML lowercases attribute names; both the filter and the
 * `attributeName` check are dead — ERRATA #17). Only text-node insertion
 * triggers the reformat.
 *
 * The shared debounced formatter is passed in by the entry point (nova.ts)
 * so the 200 ms debounce state stays a single instance across the initial
 * run, the sessionStorage trigger and this observer.
 */
export function initNovaCurrencyMutationObserver(DebouncedFormatCurrencyWithAmount: (value: any) => void): void {
	const spanElement = document.querySelector("span.money.cpc-priceTicker");
	let isFormatting = false;
  const observer = new MutationObserver((mutations) => {
    let needsFormat = false;
  if (isFormatting) return;
    for (const mutation of mutations) {
      // Catch DOM updates that Nova might do
	   if (
        mutation.type === "attributes" &&
        mutation.attributeName === "data-origMoney" &&
        (mutation.target as any).classList.contains("cpc-priceTicker")
      ) {
        console.log("[NovaPatch] Mutation detected.");
        needsFormat = true;
      }


	  // Catch new nodes being inserted that may have prices
	 if (mutation.type === "childList") {
        mutation.addedNodes.forEach((node) => {
		if (node.nodeType === 3) { // Text Node
			const parent = node.parentElement;
			if (parent && parent.matches("span.money.cpc-priceTicker")) {
				needsFormat = true;
			}
		}
		});
      }
    }

    if (needsFormat) {
      console.log("[NovaPatch] Detected DOM change — formatting again");
	  isFormatting = true;
      requestAnimationFrame(() => {
        DebouncedFormatCurrencyWithAmount(null);
        setTimeout(() => (isFormatting = false), 200);
      });
    }
  });

  observer.observe(spanElement as any, {
    childList: true,
    subtree: true,
    attributes: true,
	characterData: true,
    attributeFilter: ["data-origMoney"],
  });

  window.__novaCurrencyObserverAttached = true;
}
